import React from "react"

const WeekDays = ({ weekDays }) => {
  return (
    <div className="grid grid-cols-7 gap-1 relative">
      <div className="absolute bottom-1 left-0 right-0 border-b border-app-content-subtle/30" />
      {weekDays.map((day, idx) => (
        <div
          key={`weekday-${idx}`}
          className="h-10 flex items-center justify-center text-sm font-medium text-app-content"
        >
          {day}
        </div>
      ))}
    </div>
  )
}

export default WeekDays
